<template>
    <slot></slot>

</template>

<script>
export default {
    name: 'conainer-scroll'

}
</script>

<style lang="scss" scoped>

</style>